import React, {useEffect, useReducer} from "react";

import Html from './html';
import Reducer from "./reducer";
import {loadData} from "./service";
import Context from './context';
import { initialState } from "./initialState";

const Summary = () => {
    const [state, dispatch] = useReducer(Reducer,initialState);

    useEffect(() => {
        loadData(dispatch, state.current_page, state.search_value, state.sort_key, state.sort_direction);
    }, [state.current_page, state.search_value, state.sort_key, state.sort_direction]);

    return(
        <Context.Provider value={{state, dispatch}}>
            <Html/>
        </Context.Provider>
    );
}

export default Summary;